/*import { START_MATCH as SOCKET_START_MATCH } from '../../events/DashboardToServer'

export const START_MATCH = 'START_MATCH'
export const MATCH_UPDATED = 'MATCH_UPDATED'

export const startMatch = (socket, match) => {
    socket.emit(SOCKET_START_MATCH, match)
    return { type: START_MATCH, match }
}

export const matchUpdated = match => {
    return { type: MATCH_UPDATED, match }
}*/


// WEBPACK FOOTER //
// ./src/reducers/match/actions.js